import React from 'react';

import AutocompleteDropdownComponent from './autocompleteDropdownComponent';
import InputTitleComponent from './redesign/inputComponentV2/components/inputTitleComponent/inputTitleComponent';
import UpgradeComponent from './redesign/upgradeComponent/upgradeComponent';

import './autocompleteDropdownComponentV2.css';

const AutocompleteDropdownComponentV2 = ({
  showCustomError = false,
  billingPlanFeature = null,
  titleTooltipTxt = '',
  titleTxt = '',
  subTitleComponent,
  toolTipPosition = 'right',
  ...props
}) => {
  return (
    <div
      className={`et-v2-auto-complete-dd-container ${
        props.enableAutoComplete
          ? 'et-v2-auto-complete-dd-container-auto-complete'
          : ''
      }`}>
      <UpgradeComponent billingPlanFeature={billingPlanFeature} />
      <InputTitleComponent
        billingPlanFeature={billingPlanFeature}
        titleTxt={titleTxt}
        toolTipPosition={toolTipPosition}
        toolTipTxt={titleTooltipTxt}
      />
      {subTitleComponent && subTitleComponent}
      <div
        className={`et-v2-auto-complete-dd-wrap ${
          showCustomError ? 'et-v2-auto-complete-dd-errorneous-wrap' : ''
        }`}>
        <AutocompleteDropdownComponent {...props} />
      </div>
    </div>
  );
};

export default AutocompleteDropdownComponentV2;
